export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	PRODUCT_TYPE_CATEGORIES = 'product-type-categories',
	PRODUCT_TYPES = 'product-types',
	PROJECTS = 'projects',
	ARTICLES = 'articles',

	COLOR_GROUPS = 'color-groups',
	COLORS = 'colors',

	COMPONENTS = 'components',
	COMPONENT_VARIATIONS = 'component-variations',

	INVESTMENTS = 'investments',
	EXPORT_INVESTMENTS = 'export-investments',

	COMPANIES = 'companies',
	ADMINS = 'admins',
	USERS = 'users',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	ROLES = 'roles',
	CONTENT = 'content',
}
